export enum pinStatus {
  Cool = "Cool",
  Hot = "Hot",
  Super = "Super",
}

export const urlByStatusWithPinStatus = (status: string, key?: string) => {
  if (status === "icon" && key) {
    return `${process.env.PUBLIC_URL}/joojum/image/${key}/icon.jpeg`;
  }

  if (status === pinStatus.Cool || status === "") {
    return `${process.env.PUBLIC_URL}/Cool.png`;
  }

  if (status === pinStatus.Hot) {
    return `${process.env.PUBLIC_URL}/Hot.png`;
  }

  if (status === pinStatus.Super) {
    return `${process.env.PUBLIC_URL}/Super.png`;
  }

  return `${process.env.PUBLIC_URL}/Cool.png`;
};

export const urlByStatus = (status: string) => {
  if (status === pinStatus.Cool || status === "") {
    return `${process.env.PUBLIC_URL}/Cool.png`;
  }

  if (status === pinStatus.Hot) {
    return `${process.env.PUBLIC_URL}/Hot.png`;
  }

  if (status === pinStatus.Super) {
    return `${process.env.PUBLIC_URL}/Super.png`;
  }

  return `${process.env.PUBLIC_URL}/Cool.png`;
};
